export const screenshotsData = {
	heading: 'Why choose VPS?',
	subHeading:
		'Raise the bar with AWS-managed VPS from $39.95/mo',
};
